import PropTypes from 'prop-types';

export const WIZARD_CLASSNAME = 'wizard-steps';
export const STEP_CLASSNAME = 'step';
export const BREADCRUMBS_CLASSNAME = 'wizard-breadcrumbs';
export const STEP_STATUS_ACTIVE = 'step-active';

export const STEPS_PROPTYPE = PropTypes.shape({
    id: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ]),
    title: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number
    ])
});